export default __webpack_public_path__ + "static/media/pexels-photo-220453.0847a8d5.jpeg";